package com.dwarshb.bms

import kotlin.String

public data class User(
  public val idToken: String,
  public val email: String,
  public val refreshToken: String?,
  public val name: String?,
  public val localId: String?,
  public val phone: String?,
)
